import _get from 'lodash/get';
import PropTypes from 'prop-types';

// components
import { CmsComponentSwitch } from 'src/cms/CmsComponentSwitch';
import { ContentfulToolbar } from 'src/components/ContentfulToolbar';
import { TemplateWrapper } from 'src/templates';

// helpers
import LegacyScripts from 'src/components/LegacyScripts';
import { CmsThemes, ContentfulTemplates } from 'src/lib/constants';
import { TemplateFieldShape } from 'src/lib/prop-types';

const propTypes = {
  fields: TemplateFieldShape.isRequired,
  locale: PropTypes.string,
  children: PropTypes.element,
};

const UseCaseTemplate = ({ fields, locale, ...props }) => {
  const metaData = {
    metaTitle: _get(fields, 'metaTitle', fields['meta-title']),
    metaDescription: _get(
      fields,
      'metaDescription',
      fields['meta-description'],
    ),
  };

  return (
    <TemplateWrapper
      meta-title={metaData?.metaTitle}
      meta-description={metaData?.metaDescription}
      hasFooterCta={fields?.hasFooterCta}
      noIndex={fields?.metaNoindex}
      locale={locale}
      cmsTheme={CmsThemes.WEB3}
    >
      <div data-testid={ContentfulTemplates.USE_CASE}>
        <CmsComponentSwitch components={fields?.components} />
        {props.children}
      </div>
      <LegacyScripts />
      <ContentfulToolbar />
    </TemplateWrapper>
  );
};
UseCaseTemplate.propTypes = propTypes;

export default UseCaseTemplate;
